import axios from '@/axios.js'
let safe = 'd86f4d7f-65d3-413e-aed4-2ae3816d5145'

export default {
  fetchPayslip({commit}){
    return new Promise((resolve, reject) => {
      axios.get(`/payslips`)
        .then((response) => {
          commit('SET_PAYSLIPS', response.data)
          resolve(response)
        })
        .catch((error) => { 
          console.log(error)
          reject(error) 
        })
    })
  },
  fetchPayslipSender({commit},id){
    return new Promise((resolve, reject) => {
      axios.get(`/payslipsenders/${id}`)
        .then((response) => {
          commit('SET_PAYSLIPSENDER', response.data)
          resolve(response)
        })
        .catch((error) => { 
          console.log(error)
          reject(error) 
        })
    })
  },
}
